/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const AssignmentCompleteIcon = /*#__PURE__*/ createSvgIcon(
  'AssignmentCompleteIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <circle cx={10} cy={10} r={9.167} fill="currentColor" />
          <path
            d="M8.305 12.151l5.297-5.297a.6.6 0 01.437-.187.6.6 0 01.438.187.608.608 0 01.187.445c0 .172-.062.32-.187.446l-5.735 5.75a.6.6 0 01-.437.187.6.6 0 01-.438-.187L5.18 10.807a.582.582 0 01-.18-.445.637.637 0 01.196-.445.608.608 0 01.445-.188c.172 0 .32.063.445.188l2.219 2.234z"
            fill="#fff"
          />
        </>
      ),
    },
  },
  false
);

export default AssignmentCompleteIcon;
